import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { emptyArray } from 'src/utils/helpers';

const NotificationsSettingListRowSkeleton: FC = (): JSX.Element => {
  return (
    <div className="notifications-setting-list-row notifications-setting-list-row__grid-template mr-4">
      {emptyArray(2).map((_, index) => (
        <div key={String(index) + '-skeleton-part-1'} className="notifications-setting-list-row__element flex-wrap">
          <Skeleton width="90%" height={16} />

          <Skeleton width="60%" height={16} />
        </div>
      ))}

      {emptyArray(2).map((_, index) => (
        <div key={String(index) + '-skeleton-part-2'} className="notifications-setting-list-row__element flex-wrap">
          <Skeleton width="90%" height={16} />
          <Skeleton width="90%" height={16} />
          <Skeleton width="20%" height={16} />
        </div>
      ))}

      <div className="notifications-setting-list-row__element flex-wrap">
        <Skeleton width="30%" height={16} />
        <Skeleton width="80%" height={16} />
      </div>

      <div className="notifications-setting-list-row__element">
        <Skeleton width="80%" height={16} />
      </div>

      <div className="notifications-setting-list-row__element gap-20">
        <Skeleton width={50} height={30} style={{ borderRadius: 30 }} />
        <Skeleton width={25} height={25} />
      </div>
    </div>
  );
};

export default NotificationsSettingListRowSkeleton;
